var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7494 32.4813C9.61641 32.4813 3 25.869 3 17.7404C3 9.61236 9.61696 3 17.7494 3C25.883 3 32.4994 9.61236 32.4994 17.7404C32.4994 25.869 25.883 32.4813 17.7494 32.4813ZM17.7494 4.63268C10.5177 4.63268 4.63368 10.5131 4.63368 17.7404C4.63368 24.9683 10.5177 30.8486 17.7494 30.8486C24.9817 30.8486 30.8657 24.9683 30.8657 17.7404C30.8657 10.5125 24.9817 4.63268 17.7494 4.63268Z",
    fill: "#059D39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3952 19.6945C18.2841 19.6945 18.173 19.6722 18.0679 19.6265L9.41368 15.849C9.00036 15.6684 8.81194 15.1873 8.99219 14.7742C9.17244 14.3617 9.65492 14.1728 10.0682 14.353L17.5783 17.6308V10.3322C17.5783 9.88107 17.9443 9.5159 18.3952 9.5159C18.8461 9.5159 19.212 9.88107 19.212 10.3322V18.8782C19.212 19.1536 19.0732 19.4105 18.8423 19.5612C18.7072 19.6494 18.5515 19.6945 18.3952 19.6945Z",
    fill: "#059D39"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.80831b9132d2aca47dbd8796307f7a41.svg";
export { ForwardRef as ReactComponent };